class ProductState extends HTMLElement {}

export default ProductState;
